import {
  LESS_984_MEDIA_QUERY,
  LESS_768_MEDIA_QUERY,
  LESS_1140_MEDIA_QUERY,
  LESS_1024_MEDIA_QUERY,
} from '../../../../consts/adaptive';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { cssToObject } from '../../../../../utils/cssToObject';

const {theme} = defaultTheme;

export const styles = {
  '@keyframes fadeFromTop': {
    from: {
      opacity: 0,
      transform: 'translateY(70%)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },

  '@keyframes fadeToTop': {
    from: {
      opacity: 1,
      transform: 'translateY(0)',
    },
    to: {
      opacity: 0,
      transform: 'translateY(20%)',
    },
  },

  container: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    padding: 16,
    backgroundColor: theme.colorVariables.bgPrimary,
    boxSizing: 'border-box',

    [LESS_768_MEDIA_QUERY]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: 12,
    }
  },

  ratingInner: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 52,

    [LESS_1140_MEDIA_QUERY]: {
      marginRight: 12,
    },

    [LESS_1024_MEDIA_QUERY]: {
      marginRight: 32,
    },

    [LESS_984_MEDIA_QUERY]: {
      marginRight: 12,
    },

    [LESS_768_MEDIA_QUERY]: {
      marginRight: 0,
      width: '100%',
    },
  },

  reviewAmountWrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 4,

    [LESS_768_MEDIA_QUERY]: {
      justifyContent: 'center',
    },
  },

  reviewAmount: {
    ...cssToObject(theme.mixin.fontTitleS),
    margin: [0, 0, 0, 12],
    whiteSpace: 'nowrap',
  },

  reviewAmountDetails: {
    display: 'flex',
    flexFlow: 'column nowrap',
    minWidth: 192,
  },

  reviewAmountHeadings: {
    ...cssToObject(theme.mixin.fontCaptionS),
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.colorVariables.textNoteDark,
    marginBottom: 4,
  },

  reviewAmountBar: {
    height: 5,
    borderRadius: 4,
    background: theme.colorVariables.bgRatingNormal,
    marginBottom: 4,
  },

  bar: {
    height: 5,
    width: 0,
    borderRadius: [4, 0, 0, 4],
  },

  reviewAmountInner: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  amount: {
    ...cssToObject(theme.mixin.fontCaptionM),
    color: theme.colorVariables.textDark,
  },

  amountGood: {
    color: theme.colorVariables.bgRatingGood,
  },

  detailButton: {
    display: 'flex',
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontWeight: '600',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: theme.colorVariables.link,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',

    ['&:hover']: {
      color: theme.colorVariables.linkHover,
    },
  },

  detailWrapper: {
    animation: 'fadeFromTop 0.2s ease-in-out',
    animationFillMode: 'forwards',

    [LESS_768_MEDIA_QUERY]: {
      marginTop: 20,
      width: '100%',
    },
  },

  detailWrapperCloseAnimation: {
    animation: 'fadeToTop 0.15s ease-out',
    animationFillMode: 'forwards',
  },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
